import * as Yup from 'yup';

import { addressValidationSchema } from 'src/common/validation/address';
import type { IAddress } from 'src/types/IAddress';
import type { IVendorLeadProduct } from 'src/types/vendors/IVendorLeadProduct';

export type IVendorProductLeadAddressTabFormValues = {
  address: IAddress;
};

export const vendorProductLeadContactTabValidationSchema = Yup.object<IVendorProductLeadAddressTabFormValues>().shape({
  address: addressValidationSchema,
});

export function toVendorProductLeadAddressTabInitialValues(
  vendorLeadProduct: IVendorLeadProduct,
  addressFieldName: Extract<keyof IVendorLeadProduct, 'shippingAddress' | 'billingAddress'>
): IVendorProductLeadAddressTabFormValues {
  return {
    address: vendorLeadProduct[addressFieldName],
  };
}
